var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BreadcrumbLevel, BrowserBreadcrumbTypes, EventTypes, HttpTypes } from '@heimdallr-sdk/types';
import { formatDate, generateUUID, getUrlPath, replaceOld } from '@heimdallr-sdk/utils';
function XHRPlugin(options) {
    if (options === void 0) { options = {}; }
    var _a = options.ignoreUrls, ignoreUrls = _a === void 0 ? [] : _a, _b = options.reportResponds, reportResponds = _b === void 0 ? false : _b;
    var originalXhrProto = XMLHttpRequest.prototype;
    return {
        name: 'XHRPlugin',
        monitor: function (notify) {
            var _a = this.context, initUrl = _a.initUrl, uploadUrl = _a.uploadUrl;
            var ignore = __spreadArray(__spreadArray([], ignoreUrls, true), [uploadUrl, initUrl], false).map(function (url) { return getUrlPath(url); });
            replaceOld(originalXhrProto, 'open', function (originalOpen) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    this.httpCollect = {
                        request: {
                            method: args[0] ? args[0].toUpperCase() : args[0],
                            url: args[1]
                        },
                        response: {},
                        time: Date.now()
                    };
                    originalOpen.apply(this, args);
                };
            });
            replaceOld(originalXhrProto, 'send', function (originalSend) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var request = this.httpCollect.request;
                    var url = request.url;
                    this.addEventListener('loadend', function () {
                        var isBlock = ignore.includes(getUrlPath(url));
                        if (isBlock)
                            return;
                        var _a = this, responseType = _a.responseType, response = _a.response, status = _a.status;
                        request.data = args[0];
                        var eTime = Date.now();
                        if (reportResponds && ['', 'json', 'text'].indexOf(responseType) !== -1) {
                            this.httpCollect.response.data = typeof response === 'object' ? JSON.stringify(response) : response;
                        }
                        this.httpCollect.response.status = status;
                        this.httpCollect.elapsedTime = eTime - this.httpCollect.time;
                        notify(this.httpCollect);
                    });
                    originalSend.apply(this, args);
                };
            });
        },
        transform: function (collectedData) {
            var id = generateUUID();
            var _a = collectedData.request, method = _a.method, url = _a.url, params = _a.data, _b = collectedData.elapsedTime, elapsedTime = _b === void 0 ? 0 : _b, status = collectedData.response.status;
            this.breadcrumb.unshift({
                eventId: id,
                type: BrowserBreadcrumbTypes.XHR,
                level: status != 200 ? BreadcrumbLevel.WARN : BreadcrumbLevel.INFO,
                message: "".concat(method, " \"").concat(url, "\" width \"").concat(JSON.stringify(params), "\" took ").concat(elapsedTime / 1000, " seconds")
            });
            return {
                id: id,
                time: formatDate(),
                type: EventTypes.API,
                data: __assign({ sub_type: HttpTypes.XHR }, collectedData)
            };
        }
    };
}
export default XHRPlugin;
